import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getPENDINGAUDITORDERSTableStructure";
export const UPDATE_TABLE_DATA = "getPENDINGAUDITORDERSTableData";
export const EXPORT_TABLE_DATA = "exportPENDINGAUDITORDERSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setPENDINGAUDITORDERSTableStructure";
export const SET_TABLE_DATA = "setPENDINGAUDITORDERSTableData";
export const SET_TABLE_FILTER = "setPENDINGAUDITORDERSTableFilter";
export const SET_FILTER_CHANGE = "setPENDINGAUDITORDERSFilterChange";
export const SET_TABLE_PAGE = "setPENDINGAUDITORDERSTablePage";
export const SET_TABLE_PERPAGE = "setPENDINGAUDITORDERSTablePerPage";
export const SET_TABLE_SORTBY = "setPENDINGAUDITORDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setPENDINGAUDITORDERSTableSortOrder";
export const SET_EXPORT_LINK = "setPENDINGAUDITORDERSExportLink";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getPENDINGAUDITORDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getPENDINGAUDITORDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getPENDINGAUDITORDERSTableState(state) {
    return state.table_state;
  },
  getPENDINGAUDITORDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getPENDINGAUDITORDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getPENDINGAUDITORDERSTableData(state) {
    return state.table_data.data;
  },

  getPENDINGAUDITORDERSExportUrl(state) {
    return state.export_link;
  },
  getPENDINGAUDITORDERSCallStatuses(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.call_statuses[0];
  },
  getPENDINGAUDITORDERSUploadType(state) {
    return state.table_structure.type;
  },
  getPENDINGAUDITORDERSExtraData(state) {
    return state.table_structure.reason_data;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/order_management/pending_audit_orders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/order_management/pending_audit_orders/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/pending_audit_orders/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    // console.log("order state of filter update", filter);
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
